export const VerticalLine = () => {
  return <div className='w-[0.125rem] h-8 bg-dark-color'></div>;
};

export default VerticalLine;
